import { useCallback } from "react"
import { useApolloClient, gql } from "@apollo/client"
import { LogError } from "../helpers/logger"

const CHECK_EMAIL = gql`
  query EmailChecker(
    $selected_staff_id: String!
    $email: String!
    $organization_id: ID!
    $block_name: String!
  ) {
    staffEmailAddressVerifier(
      selected_staff_id: $selected_staff_id
      email: $email
      organization_id: $organization_id
      block_name: $block_name
    ) {
      data
    }
  }
`

export default function useStaffEmailChecker() {
  const client = useApolloClient()

  const checkStaffEmail = useCallback(
    async (args) => {
      const { email, selected_staff_id, organization_id } = args
      if (!email || !organization_id) return true

      try {
        const result = await client.query({
          query: CHECK_EMAIL,
          fetchPolicy: "network-only", // naturally deduplicates requests
          variables: {
            selected_staff_id: selected_staff_id || "",
            email: email.toLowerCase() || "",
            organization_id: organization_id || "",
            block_name: "staff",
          },
        })

        const dataRes = result?.data?.staffEmailAddressVerifier?.data
        return dataRes === "" ? true : false
      } catch (err) {
        LogError("checkStaffEmail error", err)
        return false // Fail uniqueness check on error to be safe
      }
    },
    [client],
  )

  return { checkStaffEmail }
}
